<template>
  <div id="login">
  <div class="mark" v-if="qyLoginLoading">
    <img src="@/assets/images/loading.gif"/>
  </div>
  <div class="login" @click.stop="domClick($event)">
  <div class="logoTop"><img src="@/assets/images/Rlogo.svg"/></div>
  <p class="school">{{$t('LanguageLib.SYSTEM_NAME')}}</p>
  <div class="loginContent">
    <el-form>
      <el-input auto-complete="on" autocomplete="on" name="test" prefix-icon="el-icon-user" :style="LoginStyle == false ? styleObjectBlur : styleObjectFous" maxlength="20" placeholder="点击下方企业微信登录" v-model="phone" @keyup.native="getOwerList($event)" @input="inputPhone()" @change="changePhone()" @focus="getFocus('1')" @blur="getBlur('1')" :disabled="true"></el-input>
      <div class="company">
        <el-select v-model="company" :style="companyStyle == false ? styleObjectBlur : styleObjectFous" :placeholder="$t('LanguageLib.COMPANY')" @change="chooseCompany" @focus="getFocus('2')" @blur="getBlur('2')" :disabled="true">
        <el-option
          v-for="item in owerList"
          :key="item.ownerId"
          :label="item.ownerName"
          :value="item.ownerId">
        </el-option>
      </el-select>
      <img v-if="companyLoading" src="../../assets/images/loading.gif"/>
      </div>
      <el-input type="password" prefix-icon="el-icon-key" :style="PswStyle == false ? styleObjectBlur : styleObjectFous" class="inputPassword" v-model="passWord" :placeholder="$t('LanguageLib.PASSWORD')" @keyup.enter.native="submit" @focus="getFocus('3')" @blur="getBlur('3')" :disabled="true"></el-input>
      <!-- <el-button @click="login(true)" :loading="loadingLogin">{{$t('LanguageLib.LOG_IN')}}</el-button> -->
      <a :href="'https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=wwc0632cef2973f49e&redirect_uri=' + $commonfun.encodeUrl(CallbackUrl)+'&state=bbc&usertype=member'"><img src="//wwcdn.weixin.qq.com/node/wwopen/wwopenmng/style/images/independent/brand/200x40_white$a4048eee.png" srcset="//wwcdn.weixin.qq.com/node/wwopen/wwopenmng/style/images/independent/brand/200x40_white_2x$d94d1641.png 2x" alt="企业微信登录"></a>
    </el-form>
  </div>
  <div class="warp-language">
    <i class="iconfont">&#xe612;</i>
    <el-select class="language" v-model="lang" placeholder="简体中文" @change='changlan()'>
      <el-option value="CHS" label="简体中文">
      </el-option>
      <el-option value="ENG" label="English">
      </el-option>
      <el-option value="JP" label="日本語">
      </el-option>
    </el-select>
  </div>
  </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import md5 from 'js-md5'
import loginapi from '../../api/login'
import baseUrl from '@/utils/base'
export default {
  data () {
    return {
      CallbackUrl: baseUrl.CallbackUrl,
      phone: '', // 用户名
      owerList: [], // 公司列表
      passWord: '', // 密码
      company: '', // 公司名称
      ownerid: '', // 公司ownerid
      lang: this.$commonfun.localStorage.getitem('lang') ? this.$commonfun.localStorage.getitem('lang') : 'CHS', // 语言类型
      loadingLogin: false, // 登录loding
      loadingSelect: true, // 加载公司ldoing
      qyLoginLoading: false, // 扫码登录中
      companyLoading: false, // 获取公司loading
      LoginStyle: false, // 账号input样式
      companyStyle: false, // 公司select样式
      PswStyle: false, // 密码input样式
      styleObjectFous: {
        'border-bottom': '1px solid #3BC6B9'
      },
      styleObjectBlur: {
        'border-bottom': '1px solid #999999'
      }
    }
  },
  methods: {
    // 用户名改变input
    inputPhone () {
      this.owerList = []
      this.company = ''
      this.ownerid = ''
    },
    // 用户名改变change
    changePhone () {
      this.owerList = []
      this.company = ''
      this.ownerid = ''
      if (this.$commonfun.localStorage.getitem('isAjax') === '1') {
        this.$commonfun.localStorage.setitem('isAjax', '2')
        this.getOwer()
      }
    },
    // keyUp
    getOwerList (e) {
      if (e.keyCode === 13 || e.keyCode === 8 || e.keyCode === 46) {
        this.$commonfun.localStorage.setitem('isAjax', '1')
        if (e.keyCode === 13) {
          this.getOwer()
        }
      }
    },
    // 点击获取公司
    domClick (e) {
      if (this.company === '' && this.phone !== '' && e.target.type !== 'text' && e.target.tagName !== 'BUTTON' && e.target.tagName !== 'SPAN' && e.target.tagName !== 'IMG') {
        this.$commonfun.localStorage.setitem('isAjax', '2')
        this.getOwer()
      }
    },
    // 获取公司列表函数
    getOwer () {
      if (this.phone === '') {
        this.$message.success(this.$t('LanguageLib.PLEASE_ENTER_ACCOUNT'))
        return false
      }
      if (this.companyLoading === false) {
        this.companyLoading = true
        loginapi.getownerlist('get', '/login/getownerlist?useraccount=' + this.phone)
          .then(res => {
            this.owerList = res.data
            this.company = res.data[0].ownerName
            this.ownerid = res.data[0].ownerId
            this.companyLoading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
            this.owerList = []
            this.company = ''
            this.ownerid = ''
            this.companyLoading = false
          })
      }
    },
    // 选择公司
    chooseCompany (val) {
      this.ownerid = val
    },
    // 获取焦点 1账号框 2公司框 3密码框  公司列表获取焦点时判断是否请求获取公司的接口
    getFocus (type) {
      if (type === '1') {
        this.LoginStyle = true
        this.$commonfun.localStorage.setitem('isAjax', '1')
      }
      if (type === '2') {
        this.companyStyle = true
        if (this.company === '' && this.phone !== '') {
          this.getOwer()
        }
      }
      if (type === '3') {
        this.PswStyle = true
      }
    },
    // 失去焦点 1账号框 2公司框 3密码框
    getBlur (type) {
      if (type === '1') {
        this.LoginStyle = false
      }
      if (type === '2') {
        this.companyStyle = false
      }
      if (type === '3') {
        this.PswStyle = false
      }
    },
    // 输完密码回车登录
    submit () {
      this.login(true)
    },
    // 切换语言
    changlan () {
      this.$commonfun.localStorage.setitem('lang', this.lang)
      if (this.lang === 'CHS') {
        this.$i18n.locale = 'zh'//  切换语言
      }
      if (this.lang === 'ENG') {
        this.$i18n.locale = 'en'//  切换语言
      }
      if (this.lang === 'JP') {
        this.$i18n.locale = 'jp'//  切换语言
      }
      document.title = this.$t('LanguageLib.SYSTEM_NAME')
    },
    // 登录
    login (status) {
      if (this.phone === '' && this.passWord === '') {
        this.$message.success(this.$t('LanguageLib.ACCOUNT_PASSWORD_CANNOT_EMPTY'))
        return false
      }
      if (this.phone === '') {
        this.$message.success(this.$t('LanguageLib.InfoAccountCannotEmpty'))
        return false
      }
      if (this.ownerid === '') {
        this.$message.success(this.$t('LanguageLib.InfoPleaseSelectCompany'))
        return false
      }
      if (this.passWord === '') {
        this.$message.success(this.$t('LanguageLib.InfoYourPasswordIsEmpty'))
        return false
      }
      this.loadingLogin = true
      loginapi.ordinaryLogin('get', '/login/Check?ownerid=' + this.ownerid + '&userAccount=' + this.phone + '&pwd=' + md5(this.passWord))
        .then(res => {
          // this.$commonfun.localStorage.clearall()
          this.$commonfun.localStorage.removeitem('routekey')
          this.$commonfun.localStorage.removeitem('ownerId')
          this.$commonfun.localStorage.removeitem('ownerCode')
          this.$commonfun.localStorage.removeitem('userId')
          this.$commonfun.localStorage.removeitem('sid')
          this.$commonfun.localStorage.removeitem('token')
          this.$commonfun.localStorage.removeitem('userName')
          this.$commonfun.localStorage.removeitem('ownerName')
          this.$commonfun.localStorage.removeitem('OwnerLanguage')
          this.$commonfun.localStorage.removeitem('qyuser')
          this.$commonfun.localStorage.removeitem('portrait')
          this.$commonfun.localStorage.removeitem('loginstatus')
          this.$commonfun.localStorage.removeitem('title')
          this.$commonfun.localStorage.removeitem('topath')
          this.$commonfun.localStorage.removeitem('keys')
          this.$commonfun.localStorage.removeitem('moduleCode')
          this.$commonfun.localStorage.setitem('ownerId', res.data.ownerId)
          this.$commonfun.localStorage.setitem('ownerCode', res.data.ownerCode)
          this.$commonfun.localStorage.setitem('userId', res.data.userId)
          this.$commonfun.localStorage.setitem('sid', res.data.sid)
          this.$commonfun.localStorage.setitem('token', res.data.token)
          this.$commonfun.localStorage.setitem('lang', this.lang)
          this.$commonfun.localStorage.setitem('userName', res.data.userName)
          this.$commonfun.localStorage.setitem('ownerName', res.data.ownerName)
          this.$commonfun.localStorage.setitem('OwnerLanguage', res.data.ownerLanguage + '')
          this.$commonfun.localStorage.setitem('qyuser', 'false')
          if (res.data.portrait !== '' && res.data.portrait !== null) {
            if (res.data.portrait.indexOf('.jpg') === -1) {
              res.data.portrait = ''
            }
          }
          this.$commonfun.localStorage.setitem('portrait', res.data.portrait)
          if (status) {
            loginapi.OwnerModuleOpen('get', '/ownerinfo/GetModules')
              .then(result => {
                var moduleCodeArr = []
                for (var i in result.data) {
                  moduleCodeArr.push(result.data[i].moduleCode)
                }
                this.$commonfun.localStorage.setitem('moduleCode', JSON.stringify(moduleCodeArr))
                this.$commonfun.localStorage.setitem('loginstatus', true)
                // 登录成功的回调
                this.loginsuccess()
                this.$router.push('/basicdata/personnelmanagement')
              })
              .catch(err => {
                this.$commonfun.console.log(err)
                this.qyLoginLoading = false
              })
          } else {
            // 登录失败的回调
            this.logineerror()
          }
          this.loadingLogin = false
        })
        .catch(err => {
          this.$commonfun.console.log(err)
          this.loadingLogin = false
        })
    },
    ...mapActions([
      'loginsuccess',
      'logineerror'
    ])
  },
  created () {
    // this.$commonfun.localStorage.clearall()
    this.$commonfun.localStorage.removeitem('routekey')
    this.$commonfun.localStorage.removeitem('ownerId')
    this.$commonfun.localStorage.removeitem('ownerCode')
    this.$commonfun.localStorage.removeitem('userId')
    this.$commonfun.localStorage.removeitem('sid')
    this.$commonfun.localStorage.removeitem('token')
    this.$commonfun.localStorage.removeitem('userName')
    this.$commonfun.localStorage.removeitem('ownerName')
    this.$commonfun.localStorage.removeitem('OwnerLanguage')
    this.$commonfun.localStorage.removeitem('qyuser')
    this.$commonfun.localStorage.removeitem('portrait')
    this.$commonfun.localStorage.removeitem('loginstatus')
    this.$commonfun.localStorage.removeitem('title')
    this.$commonfun.localStorage.removeitem('topath')
    this.$commonfun.localStorage.removeitem('keys')
    this.$commonfun.localStorage.setitem('isAjax', '1')
    this.lang = this.$commonfun.localStorage.getitem('lang') ? this.$commonfun.localStorage.getitem('lang') : 'CHS'
    if (this.lang === 'CHS') {
      this.$i18n.locale = 'zh'//  切换语言
    }
    if (this.lang === 'ENG') {
      this.$i18n.locale = 'en'//  切换语言
    }
    if (this.lang === 'JP') {
      this.$i18n.locale = 'jp'//  切换语言
    }
    var url = window.location.href
    var query = (url.indexOf('?') !== -1) ? url.substring(url.indexOf('?') + 1) : ''
    var args = {}
    var pairs = query.split(/[&;]/)
    for (var i = 0; i < pairs.length; ++i) {
      var keyValue = pairs[i].split(/=/)
      if (keyValue.length === 2) {
        args[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1])
      }
    }
    // JSON.stringify(args) !== '{}'
    if (url.indexOf('auth_code') !== -1) {
      this.qyLoginLoading = true
      loginapi.QYLogin('get', '/login/QYCheck?code=' + args.auth_code)
        .then(res => {
          // this.$commonfun.localStorage.clearall()
          this.$commonfun.localStorage.removeitem('routekey')
          this.$commonfun.localStorage.removeitem('ownerId')
          this.$commonfun.localStorage.removeitem('ownerCode')
          this.$commonfun.localStorage.removeitem('userId')
          this.$commonfun.localStorage.removeitem('sid')
          this.$commonfun.localStorage.removeitem('token')
          this.$commonfun.localStorage.removeitem('userName')
          this.$commonfun.localStorage.removeitem('ownerName')
          this.$commonfun.localStorage.removeitem('OwnerLanguage')
          this.$commonfun.localStorage.removeitem('qyuser')
          this.$commonfun.localStorage.removeitem('portrait')
          this.$commonfun.localStorage.removeitem('loginstatus')
          this.$commonfun.localStorage.removeitem('title')
          this.$commonfun.localStorage.removeitem('topath')
          this.$commonfun.localStorage.removeitem('keys')
          this.$commonfun.localStorage.removeitem('moduleCode')
          this.$commonfun.localStorage.setitem('ownerId', res.data.ownerId)
          this.$commonfun.localStorage.setitem('ownerCode', res.data.ownerCode)
          this.$commonfun.localStorage.setitem('userId', res.data.userId)
          this.$commonfun.localStorage.setitem('sid', res.data.sid)
          this.$commonfun.localStorage.setitem('token', res.data.token)
          this.$commonfun.localStorage.setitem('lang', this.lang)
          this.$commonfun.localStorage.setitem('userName', res.data.userName)
          this.$commonfun.localStorage.setitem('ownerName', res.data.ownerName)
          this.$commonfun.localStorage.setitem('OwnerLanguage', res.data.ownerLanguage + '')
          this.$commonfun.localStorage.setitem('qyuser', 'true')
          if (res.data.portrait !== '' && res.data.portrait !== null) {
            if (res.data.portrait.indexOf('.jpg') === -1) {
              res.data.portrait = ''
            }
          }
          this.$commonfun.localStorage.setitem('portrait', res.data.portrait)
          this.$commonfun.localStorage.setitem('loginstatus', true)
          loginapi.OwnerModuleOpen('get', '/ownerinfo/GetModules')
            .then(result => {
              var moduleCodeArr = []
              for (var i in result.data) {
                moduleCodeArr.push(result.data[i].moduleCode)
              }
              this.$commonfun.localStorage.setitem('moduleCode', JSON.stringify(moduleCodeArr))
              loginapi.getUserAgentconfig('get', '/user/agentconfig?url=' + this.$commonfun.encodeUrl(window.location.href))
                .then(result2 => {
                  window.wx.agentConfig({
                    beta: true,
                    corpid: result2.data.corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
                    agentid: result2.data.agentId, // 必填，企业微信的应用id （e.g. 1000247）
                    timestamp: result2.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: result2.data.nonceStr, // 必填，生成签名的随机串
                    signature: result2.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                    jsApiList: ['selectExternalContact', 'selectEnterpriseContact', 'openUserProfile', 'selectCorpGroupContact'], // 必填，传入需要使用的接口名称
                    success: (result) => {
                      //  wx.agentConfig成功回调后，WWOpenData 才会注入到 window 对象上面
                      window.WWOpenData.bind(document.querySelector('ww-open-data'))
                      // 登录成功的回调
                      this.loginsuccess()
                      this.$router.push('/basicdata/personnelmanagement')
                      this.qyLoginLoading = false
                    },
                    fail: (res) => {
                      console.log('查看错误信息' + JSON.stringify(res))
                      // 登录成功的回调
                      this.loginsuccess()
                      this.$router.push('/basicdata/personnelmanagement')
                      this.qyLoginLoading = false
                    }
                  })
                })
                .catch(err => {
                  console.log(err)
                  // 登录成功的回调
                  this.loginsuccess()
                  this.$router.push('/basicdata/personnelmanagement')
                  this.qyLoginLoading = false
                })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
              this.qyLoginLoading = false
            })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
          this.qyLoginLoading = false
        })
    }
  }
}
</script>
<style lang="scss">
#login {
width: 100%;
height: 100%;
background: url(../../assets/images/backLogo.png) no-repeat;
text-align: center;
.mark{
position: absolute;
top: 0;
left: 0;
height: 100%;
width: 100%;
display: flex;
justify-content: center;
align-items: center;
z-index: 9999;
background: rgba(0,0,0,.7);
}
.login{
width: 100%;
height: 100%;
display: flex;
flex-direction: column;
justify-content:center;
background-color: rgba(10,108,99,0.7);
.logoTop{
img{
width: 197px;
height: 119px;
}
}
.school{
font-size:30px;
font-weight:400;
color:rgba(255,255,255,1);
line-height:42px;
letter-spacing:2px;
margin-bottom:12px;
}
.loginContent{
width:200px;
height:260px;
background:rgba(255,255,255,1);
border-radius:11px;
margin:0 auto;
padding: 25px 47px 0 52px;
input{
height: 36px;
border:none;
border-radius: 0;
}
.company{
position:relative;
.el-select{
height: 36px;
border:none;
border-radius: 0;
margin:8px 0;
input{
background: #F5F7FA url(../../assets/images/company.svg) no-repeat 7px 7px;
padding-left: 30px;
}
}
img{
position: absolute;
left: 32px;
top: 17px;
height: 15px;
}
}
.el-button{
width:200px;
height:40px;
background:rgba(59,198,185,1);
border-radius:4px;
margin:29px 0 10px;
color:#fff;
}
.el-icon-user, .el-icon-key{
font-size:18px;
line-height: 36px;
font-weight: 0;
color: #aaa;
}
}
.warp-language{
  width: 299px;
  margin: 0 auto;
  position: relative;
  .iconfont{
    position: absolute;
    right: 110px;
    top: 20px;
    color: #Fff;
    font-size: 19px;
  }
  .language{
    height: 36px;
    border:none;
    border-radius: 0;
    width: 120px;
    font-size: 14px;
    margin: 10px 0 40px 169px;
    input{
    background: none;
    background-color: none;
    border: 0;
    padding-left: 24px;
    color: #fff;
    }
  }
}

}
}
.logoTop{
  text-align: center;
}
.school{
  text-align: center;
}
.inputPassword {
  margin-bottom: 29px;
}
</style>
